import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-product-variant',
  standalone: false,
  templateUrl: './product-variant.component.html',
  styleUrl: './product-variant.component.scss',
})
export class ProductVariantComponent {
  @Input() variants: any;
  @Input() selectedVariants: any;
  @Input() variantKeys: string[] = [];
  @Output() selectVariantEmitter: EventEmitter<any> = new EventEmitter();

  get orderedKeys(): string[] {
    if (this.variantKeys && this.variantKeys.length > 0) {
      return this.variantKeys;
    }
    return this.variants ? Object.keys(this.variants) : [];
  }

  objectKeys(obj: object | null | undefined): string[] {
    if (this.variantKeys && this.variantKeys.length > 0) {
      return this.variantKeys;
    }
    return Object.keys(obj ?? {});
  }

  selectVariant(key: any, variant: any) {
    this.selectVariantEmitter.emit({ key: key, variant: variant });
  }

  shouldDisplayOutsideTable(label: string): boolean {
    if (!label) return false;

    const outsideTableVariants = [
      'sizes', 'size', 'sizes:', 'size:',
      'colors', 'color', 'colors:', 'color:',
      'finishes', 'finish', 'finishes:', 'finish:'
    ];

    const normalizedLabel = label.toLowerCase().trim();
    return outsideTableVariants.some(variant => normalizedLabel.includes(variant));
  }

  hasTableVariants(): boolean {
    if (!this.variants) return false;

    const keys = Object.keys(this.variants);
    return keys.some(key => {
      const variant = this.variants[key];
      return variant?.variant?.label && !this.shouldDisplayOutsideTable(variant.variant.label);
    });
  }

  getTableVariantKeys(): string[] {
    if (!this.variants) return [];

    return this.orderedKeys.filter(key => {
      const variant = this.variants[key];
      return variant?.variant?.label && !this.shouldDisplayOutsideTable(variant.variant.label);
    });
  }

  getCleanValue(value: string, label: string): string {
    if (!value || !label) return value;
    
    const normalizedLabel = label.toLowerCase().replace(/:$/, '').trim();
    const normalizedValue = value.toLowerCase().trim();
    
    if (normalizedValue.startsWith(normalizedLabel)) {
      // Remove the label from the start of the value, including any following colon or space
      let cleaned = value.substring(normalizedLabel.length).trim();
      if (cleaned.startsWith(':')) {
        cleaned = cleaned.substring(1).trim();
      }
      return cleaned || value;
    }
    
    return value;
  }

  hasRealTechnicalVariants(): boolean {
    if (!this.variants) return false;

    const technicalKeywords = [
      'measuring', 'range', 'resolution', 'accuracy', 'weight', 'dimensions',
      'power', 'voltage', 'current', 'capacity', 'speed', 'torque', 'pressure',
      'temperature', 'protection', 'class', 'standard', 'certificate'
    ];

    const nonTechnicalKeywords = [
      'sold by', 'sales unit', 'unit', 'packing', 'packaging', 'carton'
    ];

    const keys = this.getTableVariantKeys();
    return keys.some(key => {
      const label = this.variants[key]?.variant?.label?.toLowerCase() || '';
      // It's technical if it matches technical keywords OR doesn't match non-technical ones
      return technicalKeywords.some(kw => label.includes(kw)) || 
             !nonTechnicalKeywords.some(kw => label.includes(kw));
    });
  }
}
